export default function getStudentThresholdData (threshold, breaks) {
  let data = []
  let i = 1
  breaks.forEach((breakpoint, n) => {
    const min = parseInt(i)
    let count = 0
    if (n + 1 === breaks.length) {
      while (i <= 36) {
        if (threshold[i]) {
          count += threshold[i]
        }
        i++
      }
      data.push({min, max: 36, count})
    } else {
      while (i <= breakpoint) {
        if (threshold[i]) {
          count += threshold[i]
        }
        i++
      }
      data.push({min, max: i - 1, count})
    }
  })
  return data
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getStudentThresholdData.js